export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11917.3471973c.jpg";